// import { faBold } from '@fortawesome/free-solid-svg-icons';
// import { withStyles } from '@material-ui/core/styles';

// const useStyles = makeStyles((theme) => ({
export const styles = (theme) => ({
  img: {
    width: '100%',
  },
  title: {
    fontWeight: 'Bold',
  },
  time: {
    color: '#555',
  },
  ertitle: {
    fontWeight: 'Bold',
    color: '#ff0000',
  },
  ertime: {
    color: '#ff0000',
  },
});
